/**
 * Base contract for workflow module bridges that drive in-shell view state
 * instead of Angular child routes.
 */
export abstract class WorkflowModuleBridge {
  abstract syncView(extraParams?: Record<string, unknown>): Promise<void>;

  /** @deprecated Prefer syncView for single-URL module shells. */
  async syncRoute(extraQuery: Record<string, string> = {}): Promise<void> {
    await this.syncView(extraQuery);
  }
}
